import * as React from 'react';
import classNames from 'classnames';
import { noop } from '@deltasierra/utilities-object';
import { useChange } from '@deltasierra/react-hooks';

export type CheckedInputProps = Omit<PuppetCheckedInputProps, 'checked' | 'onChange'> & {
    initialValue?: boolean;
    onChange?: (value: boolean) => void;
};

export const CheckedInput: React.FC<CheckedInputProps> = ({ initialValue = false, onChange = noop, ...props }) => {
    const [checked, setChecked] = useChange(initialValue, onChange);
    return <PuppetCheckedInput {...props} checked={checked} onChange={event => setChecked(event.target.checked)} />;
};

export type InputType = 'checkbox' | 'radio';

export type PuppetCheckedInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value'> & {
    label?: string;
    type?: InputType;
    checked?: boolean;
    value: string;
};

export const PuppetCheckedInput: React.FC<PuppetCheckedInputProps> = ({ label = '', type = 'checkbox', ...props }) => {
    const className = classNames(props.className, {
        'checkbox-inline': type === 'checkbox',
        'radio-inline': type === 'radio',
        'text-muted': props.disabled,
    });
    return (
        <label className={className}>
            <input
                {...props}
                type={type}
                onChange={event => props.onChange ? props.onChange({ ...event }) : noop}
            />
            {label}
        </label>
    );
};
